/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProcessState } from "./ProcessState";
import {
  ProcessStateFromJSON,
  ProcessStateFromJSONTyped,
  ProcessStateToJSON,
} from "./ProcessState";
import type { ProcessType } from "./ProcessType";
import {
  ProcessTypeFromJSON,
  ProcessTypeFromJSONTyped,
  ProcessTypeToJSON,
} from "./ProcessType";

export interface HookCreateRequest {
  triggerProcess: ProcessType;
  triggerState: ProcessState;
  name?: string | null;
  note?: string | null;
  context?: object | null;
  disabled?: boolean;
  managed?: boolean;
  uri?: string | null;
  secret?: string | null;
}

export function HookCreateRequestFromJSON(json: any): HookCreateRequest {
  return HookCreateRequestFromJSONTyped(json);
}

export function HookCreateRequestFromJSONTyped(json: any): HookCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    triggerProcess: ProcessTypeFromJSON(json["trigger_process"]),
    triggerState: ProcessStateFromJSON(json["trigger_state"]),
    name: json["name"],
    note: json["note"],
    context: json["context"],
    disabled: json["disabled"],
    managed: json["managed"],
    uri: json["uri"],
    secret: json["secret"],
  };
}

export function HookCreateRequestToJSON(
  value: HookCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    trigger_process: ProcessTypeToJSON(value.triggerProcess),
    trigger_state: ProcessStateToJSON(value.triggerState),
    name: value.name,
    note: value.note,
    context: value.context,
    disabled: value.disabled,
    managed: value.managed,
    uri: value.uri,
    secret: value.secret,
  };
}
